import React from 'react';
import PropTypes from 'prop-types';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Search from '../SearchRM';

let timeout = 0;

const SearchAutocomplete = ({
  classes,
  search,
  suggestions,
  setSearch,
  onSearch,
  getSuggestions,
  isAutoCompleteEnabled,
  isTrackerSearch = false,
}) => {
  React.useEffect(() => {
    if (isAutoCompleteEnabled) getSuggestions(search);
  }, [search]);

  const onAutocompleteChange = (e, value) => {
    if (value) {
      setSearch(value);
      clearTimeout(timeout);
      onSearch(value);
    }
  };

  const onKeyDown = (e) => {
    if (e.key === 'Enter') {
      const { value } = e.target;
      timeout = setTimeout(() => onSearch(value));
      e.target.blur();
    }
  };

  const placeholderText = isTrackerSearch ? 'Search trackers' : 'Search products';
  return (
    <Autocomplete
      classes={{
        popper: classes.container,
        option: classes.option,
        paper: classes.paper,
      }}
      data-testid="autocomplete-search-combobox"
      id="search-autocomplete"
      options={suggestions}
      value={search}
      freeSolo
      selectOnFocus={false}
      blurOnSelect
      onChange={isAutoCompleteEnabled ? onAutocompleteChange : () => null}
      renderInput={(params) => {
        return (
          <Search
            data-testid="search"
            placeholder={placeholderText}
            search={search}
            applySearch={setSearch}
            onClear={() => onSearch('', true)}
            withDebounce
            isHeaderWithin
            hasClear
            autoFocus={!search}
            onKeyDown={onKeyDown}
            ref={params.InputProps.ref}
            inputProps={params.inputProps}
          />
        );
      }}
    />
  );
};

SearchAutocomplete.propTypes = {
  classes: PropTypes.shape({}),
  search: PropTypes.string,
  suggestions: PropTypes.arrayOf(PropTypes.string),
  setSearch: PropTypes.func,
  onSearch: PropTypes.func,
  getSuggestions: PropTypes.func,
};

SearchAutocomplete.defaultProps = {
  suggestions: [],
};

export default SearchAutocomplete;
